<template>
    <div class="detail single" v-if="show">
        <p :class="['project-name', Classes().projectName]">{{ detail.project }} <span id="label-viewing" class="right" v-if="projectSelected">Viewing</span></p>
        <div v-if="!lowZoom">
            <p class="project-date">{{ DateRange() }}</p>
        </div>
        <SearchList :list="FilterList()" :searching="searching"/>
    </div>
</template>

<script>
import { FormattedDate } from "@/assets/JS/Master.js";
import SearchList from "@/components/Projects/CurrentSearch/List.vue";

export default {
    name: "TimelineProjectMapDetail",
    props: {
        show: Boolean,
        lowZoom: Boolean,
        detail: Object,
        projectSelected: Boolean,
        filtered: Array,
        searching: Boolean
    },
    components: { SearchList },
    methods: {
        DateRange: function() {
            const { dateStart, dateEnd } = this.detail;
            const formattedDate = new FormattedDate("Simple", dateStart, dateEnd);
            return formattedDate.output;
        },
        Classes: function() {
            return {
                projectName: this.lowZoom ? "project-name-small" : ""
            };
        },
        FilterList: function() {
            const filtered = this.filtered;
            let filters = [];
            for (const filter of filtered) {
                filters.push(`${filter.Name}`);
            }
            return filters;
        }
    }
};
</script>